import React, { useEffect } from 'react';
import NotFound from '../../components/NotFound';
import useHelmet from 'hooks/useHelmet';
import { I18N_AVANT_PROPERTY_TEXT_PATH } from 'constants/i18n';
import { translateText } from 'utils/i18n';

const NotFoundPage = () => {
  const { setPageTitle } = useHelmet();
  useEffect(() => {
    setPageTitle(
      translateText(`${I18N_AVANT_PROPERTY_TEXT_PATH}.notFound.notFoundText`),
    );
  }, [setPageTitle]);
  return <NotFound />;
};

export default NotFoundPage;
